import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import Logs from "src/components/logs";
import { ApiCustomer } from "src/api/api_customer";

/**
 * The properties for {@link CustomerLogsView}
 */
export type CustomerLogsViewProps = {};

/** The limit for the tablerows */
const LIMIT = 15;

/**
 * Customer View for server logs
 */
function CustomerLogsView(props: CustomerLogsViewProps) {
    const { page } = Route.useSearch();
    const data = Route.useLoaderData();
    if (!data) {
        return;
    }

    return <Logs data={data} limit={LIMIT} currentPage={page} href={"/c/logs"} />;
}

/**
 * The search parameter for this view
 */
type LogSearchParams = {
    /** The currently active page number */
    page: number;
};

export const Route = createFileRoute("/_customer/c/logs/")({
    component: CustomerLogsView,
    validateSearch: (search: Record<string, unknown>): LogSearchParams => {
        const page = Number(search?.page ?? 1);
        return { page: page <= 0 ? 1 : page };
    },
    loaderDeps: ({ search: { page } }) => ({ page }),
    loader: async ({ deps: { page } }) =>
        await ApiCustomer.changelog.get({
            limit: LIMIT,
            offset: (page - 1) * LIMIT,
        }),
});
